import { apiFetch } from '@/lib/api/http';

/** ロール別ダッシュボード（指示書 §10・§13 仮決め7 / §12 M12）. */
export interface UpcomingEvent {
  id: string;
  title: string;
  starts_at: string | null;
  venue: string | null;
}

export interface PendingSurvey {
  event_survey_id: string;
  event_id: string;
  event_title: string;
  event_type_code: string;
  survey_name: string;
  deadline_at: string | null;
  template_kind: string;
}

/** 受講生の「次にやること」、または事務局の欠席申請承認待ち 1件（D-231・D-232） */
export interface PendingEventAction {
  event_id: string;
  event_title: string;
  kind: string;
  label: string;
  detail: string | null;
  tab: string;
}

/** 事務局の「今日の対応」1行（D-108） */
export interface OperationItem {
  key: string;
  label: string;
  description: string;
  count: number;
  /** overdue（期限超過） / today（今日） / soon（近日） */
  urgency: string;
  link: string;
}

export interface EventMilestone {
  key: string;
  label: string;
  /** done（済） / current（いま） / todo（これから） */
  state: string;
}

export interface NextEvent {
  id: string;
  title: string;
  starts_at: string;
  venue: string | null;
  days_left: number;
  answered_count: number;
  target_count: number;
  milestones: EventMilestone[];
}

/** サクセス担当の「今週の面談」1件（D-110 A-7） */
export interface WeekMeeting {
  starts_at: string;
  member_name: string;
  event_id: string;
}

export interface DashboardSummary {
  widget_order: string[];
  upcoming_events: UpcomingEvent[];
  unread_messages: number;
  pending_surveys: PendingSurvey[] | null;
  pending_event_actions: PendingEventAction[] | null;
  event_todo_count: number | null;
  open_follow_up_count: number | null;
  assigned_member_count: number | null;
  open_inbox_count: number | null;
  /** 問い合わせのうち「まだ読んでいない」件数。赤丸はこちらを使う（D-145） */
  unread_inbox_count: number | null;
  operations: OperationItem[] | null;
  next_event: NextEvent | null;
  pending_evaluation_count: number | null;
  week_meetings: WeekMeeting[] | null;
}

export function fetchDashboard(): Promise<DashboardSummary> {
  return apiFetch<DashboardSummary>('/dashboard');
}
